import { ProductType } from './enums'

export default {
  AccountSSOUserInfo: '/api/account/SSOUserInfo',
  AccountSignUp: '/api/account/signup',
  AccountDetails: '/api/account/details',
  AccountUpdate: '/api/account/update',
  AccountRelations: '/api/account/relations',
  SynchronizeVisibilityTrucks: '/api/account/SynchronizeVisibilityTrucks',
  CartAdd: '/api/cart/add',
  CartBulkAdd: '/api/cart/bulk/add',
  CartBulkRemove: '/api/cart/bulk/remove',
  CartClear: '/api/cart/clear',
  CartGetAll: '/api/cart/getall',
  CartRemove: '/api/cart/remove',
  CartSubmit: '/api/cart/submit',
  CartUpdate: '/api/cart/update',
  CheckVAT: '/api/general/checkvat',
  CmsResources: '/api/cms/resources/',
  Countries: '/api/general/countries',
  Currencies: '/api/general/currencies',
  InvoiceDownload: '/api/invoice/download',
  InvoiceGetAll: '/api/invoice/getall',
  PaymentGetCCardHPP: '/api/payment/zuora2/hpp',
  PaymentGetDDebitHPP: '/api/payment/twikey/hpp',
  PaymentGetPaid: '/api/payment/getpaid',
  PaymentSetMethod: '/api/payment/SetPaymentMethod',
  PaymentSetTwikeyDirectDebit: '/api/payment/twikey/SetDirectDebit',
  ProductsGetAll: `/api/products/all`,
  ProductsGetServices: `/api/products/bytype/${ProductType.Service},${ProductType.DataService}`,
  ProductsGetApps: `/api/products/bytype/${ProductType.InVehicleApp}`,
  ProductsGetThirdPartyApps: `/api/products/bytype/${ProductType.ThirdPartySolution}`,
  ProductDetails: '/api/products/services/',
  TestConnection: '/api/general/testconnection',
  TrucksGet: '/api/trucks/details',
  TrucksGetAll: '/api/trucks/all',
  TrucksPerService: '/api/trucks/services',
  TrucksPerServiceDetail: '/api/trucks/services/detail',
  TrucksServices: '/api/trucks/services',
  CompanyService: '/api/trucks/company',
  AppCatalog: '/api/appLibrary/appsCatalog',
  AccountAppCatalog: '/api/appLibrary/AccountAppsCatalog',
  AppLibraryActivateApps: '/api/appLibrary/activateApps',
  ValidateThirdPartyAvailability: '/api/trucks/thirdPartyAvailability'
}
